import { createContext, useState } from 'react';

export const SessionContext = createContext({
  user: null,
  logged: false,
  userObject: null,
  handleSession: (session) => null
});

export const SessionContextProvider = ({ children }) => {
  const [session, setSession] = useState({
    user: null,
    logged: false,
    userObject: null
  });

  const handleSession = (session) => {
    setSession(session);
  }

  const { user, logged, userObject } = session;

  return (
    <SessionContext.Provider value={{ user, logged, userObject, handleSession }}>
      {children}
    </SessionContext.Provider>
  )

}